export default function Footer() {
  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-gray-600 to-gray-700 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">AB</span>
              </div>
              <span className="text-xl font-bold text-white">AB Dakbedekking</span>
            </div>
            <p className="text-gray-400">
              Professionele dakwerkzaamheden met 10+ jaar ervaring in Zuid-Holland, Zeeland en Brabant.
            </p>
          </div>
          
          <div>
            <h3 className="text-white font-bold mb-4">Diensten</h3>
            <ul className="space-y-2">
              <li><a href="#services" className="text-gray-400 hover:text-blue-400 cursor-pointer">Dakrenovatie</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-blue-400 cursor-pointer">Dakreparatie</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-blue-400 cursor-pointer">Dakisolatie</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-blue-400 cursor-pointer">Nieuwbouw</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-bold mb-4">Contact</h3>
            <ul className="space-y-2">
              <li className="text-gray-400">
                <i className="fas fa-phone mr-2 text-blue-400"></i>
                <a href="tel:+31683608068" className="hover:text-blue-400 cursor-pointer">+31 6 83608068</a>
              </li>
              <li className="text-gray-400">
                <i className="fas fa-envelope mr-2 text-blue-400"></i>
                <a href="mailto:ABdakbedekking@hotmail.com" className="hover:text-blue-400 cursor-pointer">ABdakbedekking@hotmail.com</a>
              </li>
              <li className="text-gray-400">
                <i className="fas fa-map-marker-alt mr-2 text-blue-400"></i>
                Zuid-Holland, Zeeland en Brabant
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-bold mb-4">Volg Ons</h3>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-gray-400 hover:text-blue-400 hover:bg-slate-700 transition-all cursor-pointer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-gray-400 hover:text-blue-400 hover:bg-slate-700 transition-all cursor-pointer">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center text-gray-400 hover:text-blue-400 hover:bg-slate-700 transition-all cursor-pointer">
                <i className="fab fa-linkedin-in"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 AB Dakbedekking. Alle rechten voorbehouden. | <a href="https://readdy.ai/?origin=logo" className="hover:text-blue-400 cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
}